import { useState, useEffect } from "react";
import { getAPI } from "./base";

export function useCategories(accountId) {
  const [data, setData] = useState([]);

  const fetchData = async (api) => {
    try {
      const response = await api.get("/category", {
        params: { account_id: accountId },
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (!accountId) return;

    const api = getAPI();
    fetchData(api);
  }, [accountId]);
  return data;
}

// Fetch All Taxonomy -> Generate Suppliers
export async function fetchTaxonomy(level, values, accountId) {
  const paths = {
    l1: "/category",
    l2: `/L2`,
    l3: "/L3",
    l4: "/L4",
  };

  const params = { account_id: accountId };
  if (level === "l2" && values) {
    params.Category = values.category;
  } else if (level === "l3" && values) {
    params.L2 = values.L2;
  } else if (level === "l4" && values) {
    params.L3 = values.L3;
  }

  try {
    const api = getAPI();
    const response = await api.get(paths[level], { params });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error(`Error fetching data for ${level}: `, response.statusText);
    }
  } catch (error) {
    console.error(`Error fetching data for ${level}: `, error);
  }
}

// Category L1
export async function fetchCategoryL1(accountId) {
  try {
    const api = getAPI();
    const response = await api.get("/category", {
      params: { account_id: accountId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

// Category L2
export async function fetchCategoryL2(l1, accountId) {
  try {
    const api = getAPI();
    const encodedL1 = encodeURIComponent(l1); // Handle special characters
    const response = await api.get(`/L2?Category=${encodedL1}`, {
      params: { account_id: accountId },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

// Category L3
export async function fetchCategoryL3(formValues, accountId) {
  try {
    const api = getAPI();

    const response = await api.get("/L3", {
      params: { L2: formValues.L2, account_id: accountId },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

// Category L4
export async function fetchCategoryL4(formValues, accountId) {
  try {
    const api = getAPI();
    const params = {
      L3: formValues.L3,
      account_id: accountId,
    };
    const response = await api.get("/L4", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching L4 data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching L4 data: ", error);
  }
}
